import { axiosInstance } from '../App';
import { SECURED_API_BASE } from './apiConfig';
import { DrugTagDTO, DrugTagRequestDTO } from '../dto/DrugTagDTO';

const BASE = `${SECURED_API_BASE}/drug-tags`;

/** Etiquetas de medicamentos de la sede, ordenadas por nombre. Pocas: sin paginación. */
export function getDrugTags(): Promise<DrugTagDTO[]> {
    return axiosInstance.get(BASE).then(r => r.data ?? []);
}

export function createDrugTag(body: DrugTagRequestDTO): Promise<DrugTagDTO> {
    return axiosInstance.post(BASE, body).then(r => r.data);
}

export function updateDrugTag(id: number, body: DrugTagRequestDTO): Promise<DrugTagDTO> {
    return axiosInstance.put(`${BASE}/${id}`, body).then(r => r.data);
}

/** Falla con DRUG_TAG_IN_USE (409) si la tienen medicamentos o restringe a una especialidad. */
export function deleteDrugTag(id: number): Promise<void> {
    return axiosInstance.delete(`${BASE}/${id}`).then(() => undefined);
}
